import { combineReducers } from "redux";
import deliveries from "./deliveries";
import draftInvoiceLines from "./draft-invoice-lines";
import draftCargoEquipment from "./draft-cargo-equipment";
import cargoEmissions from "./cargo-emissions";
import products from "./products";
import economics from "./economics";
import clients from "./clients";
import expenseAccounts from "./expenseAccounts";
import driverActivities from "./driver-activities";
import driverTimeReserved from "./driver-time-reserved";
import drivers from "./drivers";
import cargoDocuments from "./cargo-documents";
import stopDocuments from "./stop-documents";
import trailers from "./trailers";
import equipment from "./equipment";
import equipmentTypes from "./equipment-types";
import equipmentDepots from "./equipment-depots";
import rentals from "./rentals";
import siteJobs from "./site-jobs";
import rentalBilling from "./rental-billing";
import rentalInvoiceTemplate from "./rental-invoice-template";
import fractions from "./fractions";
import cargos from "./cargos";
import teams from "./teams";
import dispatchers from "./dispatchers";
import routeViewModels from "./route-views";
import cargoViews from "./cargo-views";
import consolidatedInvoicing from "./consolidated-invoices";
import routing from "./routing";
import webBookers from "./web-bookers";
import orders from "./orders";
import departments from "./departments";
import invoicing from "./invoicing";
import savedLocations from "./saved-locations";
import trackerDevices from "./tracker-devices";
import orgSettings from "./org-settings";
import userSettings from "./user-settings";
import finance from "./finance";
import archivedTrailers from "./archived-trailers";
import cargoEvents from "./cargo-events";
import liveView from "./live-view";
import cargosReport from "./cargos-report";
import schedules from "./schedules";
import extraCO2Types from "./extra-co2-types";
import calendarView from "./calendar-view";
import driverNotebooks from "./driver-notebooks";
import clientOrderTemplates from "./client-order-templates";
import contractors from "./contractors";
import subcontractors from "./subcontractors";
import stopUnitTemplates from "./stop-unit-templates";
import splitCargo from "./split-cargo";
import cargoSplitsInfo from "./cargos-splits-info";
import ssoIntegration from "./sso-integration";
import autocompleteSuggestions from "./autocomplete-suggestions";
import insights from "./insights";
import insightCostCategories from "./insightCostCategories";
import insightCostRules from "./insightCostRules";
import mailOrders from "./mail-orders";
import scanReadings from "./scan-readings";

export default combineReducers({
  deliveries,
  draftInvoiceLines,
  draftCargoEquipment,
  products,
  economics,
  clients,
  expenseAccounts,
  driverActivities,
  driverTimeReserved,
  drivers,
  cargoDocuments,
  stopDocuments,
  trailers,
  equipment,
  equipmentTypes,
  equipmentDepots,
  rentals,
  siteJobs,
  rentalBilling,
  rentalInvoiceTemplate,
  fractions,
  archivedTrailers,
  cargos,
  teams,
  consolidatedInvoicing,
  dispatchers,
  routeViewModels,
  cargoViews,
  cargoEvents,
  routing,
  cargoEmissions,
  webBookers,
  orders,
  departments,
  invoicing,
  savedLocations,
  trackerDevices,
  orgSettings,
  userSettings,
  finance,
  liveView,
  cargosReport,
  schedules,
  extraCO2Types,
  calendarView,
  driverNotebooks,
  clientOrderTemplates,
  contractors,
  subcontractors,
  stopUnitTemplates,
  splitCargo,
  cargoSplitsInfo,
  ssoIntegration,
  autocompleteSuggestions,
  insights,
  insightCostCategories,
  insightCostRules,
  mailOrders,
  scanReadings,
});
